module.exports = __webpack_public_path__ + "static/img/bj7.c8d62f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bj7.jpg
// module id = gWV4
// module chunks = 1